import useDesignTokens from '@assetron/web-common/themes/useDesignTokens';
import { useTheme } from '@mui/material';
import { useMemo } from 'react';

const useSignupVerifyEmailStyles = () => {
  const theme = useTheme();
  const tokens = useDesignTokens();

  const styles = useMemo(
    () => ({
      root: {
        width: '360px',
        marginTop: theme.sizeGuide['4xl'],
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'top',
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
      titleContainer: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: theme.sizeGuide['4xl'],
        gap: theme.sizeGuide.lg,
        [theme.breakpoints.down('sm')]: {
          height: 'auto',
          gap: theme.sizeGuide.sm,
        },
      },
      titleBox: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
          height: 'auto',
        },
      },
      textContainer: {
        display: 'flex',
        textAlign: 'center',
        width: '360px',
        [theme.breakpoints.down('sm')]: {
          height: 'auto',
          width: 'auto',
          flexDirection: 'column',
        },
      },
      emailText: {
        color: tokens.colors.text.secondary,
        wordWrap: 'break-word',
      },
      emailHighlight: {
        color: 'black',
      },
      mainContentContainer: {
        flex: 1,
      },
      mainContent: {
        marginTop: theme.sizeGuide['2xl'],
        [theme.breakpoints.down('sm')]: {
          marginTop: theme.sizeGuide['2xl'],
        },
      },
      linkContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        height: theme.sizeGuide['2xl'],
        gap: theme.sizeGuide.xs,
        alignItems: 'center',
        color: tokens.colors.text.secondary,
        [theme.breakpoints.down('sm')]: {
          flexDirection: 'row',
        },
      },
      linkText: {
        fontFamily: 'inherit',
        marginLeft: theme.sizeGuide.xs,
        color: tokens.colors.text.primary,
        cursor: 'pointer',
        textDecoration: 'none',
        display: 'flex',
        height: theme.sizeGuide['3xl'],
        '&:hover': {
          textDecoration: 'underline',
        },
      },

      button: {
        marginTop: theme.sizeGuide['3xl'],
        marginBottom: theme.sizeGuide['4xl'],
        [theme.breakpoints.down('sm')]: {
          width: 'auto',
          marginBottom: theme.sizeGuide.none,
        },
      },
    }),
    [theme, tokens],
  );

  return styles;
};

export default useSignupVerifyEmailStyles;
